import { FocusTrap } from '@trarc/pc-shared';
import { AnimatePresence } from 'framer-motion';
import React, { ReactNode, useEffect } from 'react';

import { Container, StyledMotionDiv } from './SideDrawer.styles';

interface SideDrawerProps {
  hideDrawer: () => void;
  open: boolean;
  children?: ReactNode;
  marginTop?: string;
  className?: string;
  width?: string;
  containerRef?: React.MutableRefObject<any>;
}

const SideDrawer = ({
  hideDrawer,
  open,
  children,
  marginTop,
  className,
  width = '33vw',
  containerRef,
}: SideDrawerProps) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      hideDrawer();
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
    return undefined;
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <StyledMotionDiv
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'spring', stiffness: 400, damping: 26 }}
          $marginTop={marginTop}
          $width={width}
        >
          <FocusTrap>
            <Container ref={containerRef} className={className}>
              {children}
            </Container>
          </FocusTrap>
        </StyledMotionDiv>
      )}
    </AnimatePresence>
  );
};

export default SideDrawer;
